export const getCRsIdsFromBranchList = (branchList) => branchList.reduce(
	(acc, { cashRegisters = [] }) => {
		return cashRegisters
			.filter(cr => cr.isAvailableInWebApp)
			.map(cr => cr.id)
			.concat(acc)
	}, [])
